import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import DefaultSelect from "../More/DefaultSelect";
import ProductSection from "../../components/Product/ProductSection";
import PaginationSection from "../../components/Product/Pagination";
import { BRAND_EXCLUDE_CATEGORY_LIST_URL } from "../../utils/urls";
import instance from "../../services/services";
import useUserStore from "../../store/userStore";
import { useLanguage } from "../../hooks/useLanguage";

function PurposePage() {
  const navigate = useNavigate();
  const { t } = useLanguage();
  const userInfo = useUserStore((state) => state.userInfo);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const title = searchParams.get('title'); 
  const categoryCode = location?.state?.hoveredSubCategory?.category_code || ''; // 카테고리 코드

  // 상태 관리
  const [products, setProducts] = useState([]);
  const [bestProducts, setBestProducts] = useState([]);
  const [packageFlag, setPackageFlag] = useState('N');
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentSort, setCurrentSort] = useState("regist_date");
  const itemsPerPage = 30;
  const [categoryInfo, setCategoryInfo] = useState([]);
  
  // 상품 리스트 조회
  useEffect(() => {
    const fetchProducts = async () => {
      // categoryCode가 없으면 API 호출하지 않음
      if (!categoryCode) {
        return;
      }

      try {
        setLoading(true);
        const response = await instance.post(BRAND_EXCLUDE_CATEGORY_LIST_URL, {
          category_code: categoryCode,
          member_seq: userInfo?.member_seq || '',
          offset: currentPage,
          limit: itemsPerPage,
          searchSort: currentSort
        });

        // 응답 데이터 안전하게 접근
        const responseData = response?.data?.data;
        
        if (responseData) {
          // categoryInfo 설정
          setCategoryInfo(responseData.categoryInfo || []);
          
          // bestGoods가 없으므로 빈 배열로 설정
          setBestProducts([]);
          
          // category에서 해당 카테고리의 상품 데이터 가져오기
          const categoryData = responseData.category?.[categoryCode];
          if (categoryData) {
            setTotalCount(categoryData.cntRow || 0);
            setProducts(categoryData.data || []);
          } else {
            setTotalCount(0);
            setProducts([]);
          }
          
          setPackageFlag(responseData.package_flag || 'N');
        }
      } catch (error) {
        console.error('Error fetching products:', error);
        // 에러 발생 시 기본값 설정
        setCategoryInfo([]);
        setBestProducts([]);
        setProducts([]);
        setTotalCount(0);
        setPackageFlag('N');
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, [userInfo?.member_seq, categoryCode, currentPage, currentSort]);

  // 페이지 변경 핸들러
  const handlePageChange = (page) => {
    setCurrentPage(page);
    window.scrollTo(0, 0);
  };

    // 화살표 클릭 핸들러
    const handleArrowClick = (page) => {
      handlePageChange(page);
    };

  // 정렬 변경 핸들러
  const handleSortChange = (value) => {
    setCurrentSort(value);
    setCurrentPage(1);
  };

  const BeforeContent = () => (
    <div className="auth_find" style={{marginBottom:"-16px"}}>
        <div className="product_total">
            {t('product_total_count', {count: totalCount})}
        </div>
        <DefaultSelect 
            defaultValue={currentSort}
            onChange={handleSortChange}
        />
    </div>
  );

  const AfterContent = () => (
    <div className="pagination_wrap">
        <PaginationSection
            totalCount={totalCount}
            itemsPerPage={itemsPerPage}
            currentPage={currentPage}
            onPageChange={handlePageChange}
            onArrow={handleArrowClick}
        />
    </div>
  );

  const handleBreadcrumbClick = (level) => {
    switch(level) {
      case 'home':
        navigate('/');
        break;
      default:
        // 기본 동작 (아무것도 하지 않음)
        break;
    }
  };

  return (
    <div>
      <section className="prod_section">
        <div 
          className="product_banner cate_brand"
          style={{backgroundImage:`url(${window.innerWidth > 768 ? categoryInfo?.pc_img_url : categoryInfo?.mobile_img_url})`}}
        >
          <div className="inner">
            <ul className="bread_crumb">
              <li className="group_item"><p style={{cursor: 'pointer'}} onClick={() => handleBreadcrumbClick('home')}>HOME</p></li>
              <li className="group_item"><p>PURPOSE</p></li>
              <li className="group_item active"><p>{title}</p></li>
            </ul>
            <div className="product_tit">
              <h4 className="tit">PURPOSE</h4>
              <p className="sub">{categoryInfo?.cate_comment}</p>
            </div>
          </div>
        </div>

        <div className="inner main_prod_list cate_container gap_64">
          <div>
            <div className="brand_top_tab">
              <div className="brand_section_title">BEST ITEM</div>
            </div>
            <div className="p0">
              <ProductSection
                products={bestProducts}
                showTabs={false}
                showMoreButton={false}
                useSwiper={false}
              />
            </div>
          </div>

          <div>
            <div className="brand_top_tab">
              <div className="brand_section_title">{title}</div>
            </div>
            <div className="p0">
              {loading ? (
                <div className="loading-overlay">
                  <div className="loading">로딩 중...</div>
                </div>
              ) : products.length > 0 ? (
                <ProductSection
                  products={products}
                  showTabs={false}
                  showMoreButton={false}
                  beforeContent={<BeforeContent />}
                  afterContent={<AfterContent />}
                  useSwiper={false}
                  packageFlag={packageFlag}
                />
              ) : (
                <div className="no_result">
                  <p>{t('no_product_found')}</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PurposePage;